// extracted by mini-css-extract-plugin
module.exports = {"wrap":"LeisurePriceOrigin_wrap__2ks_F"};